import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "@/App";
import { applyTheme, currentTheme } from "@/components/ThemeToggle";
import "@/styles.css";

// Apply the stored theme BEFORE first render so there's no FOUC flash.
applyTheme(currentTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
